import { useQuery } from '@apollo/client';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { FC } from 'react';
import { useParams } from 'react-router';
import {
  CampaignLeadSource as ICampaignLeadSource,
  CampaignLeadSourceVariables,
} from 'types/apollo/CampaignLeadSource';
import { CampaignLeadSourceQuery } from './campaign-lead-source.graphql';

export const CampaignLeadSource: FC = () => {
  const { campaignId: id } = useParams();
  const { data } = useQuery<ICampaignLeadSource, CampaignLeadSourceVariables>(
    CampaignLeadSourceQuery,
    {
      variables: {
        campaignId: id ?? '0',
      },
    },
  );

  return (
    <Container
      maxWidth="lg"
      sx={{
        p: {
          xs: 2,
          md: 3,
        },
      }}
    >
      <Card variant="outlined" sx={{ padding: '16px' }}>
        <Stack spacing={2}>
          {data?.campaign?.leadSource && (
            <>
              <TextField
                label="Lead Prioritization Strategy"
                value={data?.campaign?.leadSource.leadPostingStrategy}
                variant="standard"
                disabled
              />
              <TextField
                label="Lead Expiration"
                value={data?.campaign?.leadSource.expireAfterDays ?? ''}
                variant="standard"
                disabled
              />
              <TextField label="Lead Age" value={''} variant="standard" disabled />
            </>
          )}
        </Stack>
      </Card>
    </Container>
  );
};
